import script from "./flightOriginDropDown.vue?vue&type=script&setup=true&lang=ts"
export * from "./flightOriginDropDown.vue?vue&type=script&setup=true&lang=ts"

import "./flightOriginDropDown.vue?vue&type=style&index=0&id=5351ad74&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5351ad74"]])

export default __exports__